import { ConnectionStatus } from '../ConnectionStatus';

export interface SocialAccount {
  id?: number;
  projectId: number;
  blabberJaxUserId: string;
  /**
   * master account name
   * */
  socialAccountName?: string;
  socialAccountId?: string;
  socialProfilePhotoUrl?: string;
  /**
   * master account or a subaccount to post as
   * */
  postAsAccountName?: string;
  postAsAccountId?: string;
  connectionType: SocialConnectionType;
  socialAccountUserId?: string;
  token: string;
  tokenSecret?: string;
  refreshToken?: string;
  tokenExpiresIn?: Date | null;
  scope?: string;
  issuedUTC?: Date;
  connectionStatus: ConnectionStatus;
}

export enum SocialConnectionType {
  Facebook = 'Facebook',
  Twitter = 'Twitter',
  Linkedin = 'Linkedin',
  Google = 'Google',
}
